import { z } from 'zod';

/**
 * Profile type constants
 */
export const ProfileType = {
  ACCOUNT: 'account',
  ORGANIZATION: 'organization',
} as const;

export type ProfileType = (typeof ProfileType)[keyof typeof ProfileType];

/**
 * Schema for session storage data
 * Add new keys here with their corresponding schemas
 */
export const sessionStorageSchema = z.object({
  lastViewedProfile: z
    .object({
      profileId: z.string().min(1),
      profileType: z.enum(ProfileType),
    })
    .nullable(),
  /**
   * Org ids whose pending-invite prompt the user closed during this browser
   * session (KIR-4166). Session-scoped on purpose: closing it silences the
   * prompt for the current visit without permanently hiding an invite the user
   * may still want to accept later. Deliberately NOT localStorage — a
   * permanently hidden invite is how the original trap started.
   *
   * Optional as well as nullable: absent simply means "nothing dismissed yet",
   * and the wrapper validates per key (`sessionStorageSchema.shape[key]`), so
   * requiring it would only burden whole-object consumers for no gain.
   */
  dismissedInviteOrgIds: z.array(z.string()).nullable().optional(),
});

export type SessionStorageData = z.infer<typeof sessionStorageSchema>;
export type SessionStorageKey = keyof SessionStorageData;
